export enum BadgeIconType {
  AZTRIX = 'AZTRIX',
  BLOCKED = 'BLOCKED',
  MEMBER = 'MEMBER',
  FOLLOWER = 'FOLLOWER',
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  CLOSED = 'CLOSED',
}
